import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { environment } from "../../../../environments/environments";
import { AuthToken, UserInformation } from "./interfaces/auth.interface";

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);

  login(payload: { email: string; password: string }): Observable<AuthToken> {
    return this.http.post<AuthToken>(
      `${environment.apiUrl}/auth/login`,
      payload
    ).pipe(
      tap((response) => {
        sessionStorage.setItem('auth_token', response.value.idToken);
        sessionStorage.setItem('custom_token', response.value.customToken);
        if (response.value.sectors)
          sessionStorage.setItem('sectors', btoa(JSON.stringify(response.value.sectors)));

        if (response.value.companyId)
          sessionStorage.setItem('companyId', response.value.companyId.toString());

        if (response.value.userId)
          sessionStorage.setItem('userId', response.value.userId.toString());
      })
    );
  }

  getSectors(): string[] | null {
    const sectors = sessionStorage.getItem('sectors');

    if (sectors == null)
      return [];

    return JSON.parse(atob(sectors));
  }

  getToken(): string | null {
    return sessionStorage.getItem('auth_token');
  }

  getCustomToken(): string | null {
    return sessionStorage.getItem('custom_token');
  }

  logout(): void {
    sessionStorage.clear();
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }

  getUserInformation(userId: number): Observable<UserInformation> {
    return this.http.get<UserInformation>(`${environment.apiUrl}/auth/user/${userId}`);
  }

  updateUserInformation(userId: number, model: {
    name: string;
    phone: string;
    documentNumber: string
  }): Observable<UserInformation> {
    return this.http.put<UserInformation>(`${environment.apiUrl}/auth/user/${userId}`, model);
  }
}
